export enum MICROAPP {
    /**
     * @value Thumbnail
     */
    ACTION_ICON_THUMBNAIL = 'PAGE.MICROAPP_DIALOG.ACTION_ICON_THUMBNAIL',
    /**
     * @value Use this JSON in Adaptive Cards designer Sample data editor section
     * @description The description for the context block within the Adaptive Card creation form.
     *
     * ⚠️ Please do not translate the “Adaptive Cards” & “Sample data editor” terms, it should remain in English.
     */
    AC_CONTEXT_DESC = 'PAGE.MICROAPP.AC_CONTEXT_DESC',
    /**
     * @value Execution context
     * @description The title for the context block within the Adaptive Card creation form.
     */
    AC_CONTEXT_TITLE = 'PAGE.MICROAPP.AC_CONTEXT_TITLE',
    /**
     * @value Design in Adaptive Cards
     * @description The label for the Adaptive Card creation form submit button.
     *
     * ⚠️ Please do not translate the “Adaptive Cards” term, it should remain in English.
     */
    AC_CREATE_BUTTON = 'PAGE.MICROAPP.AC_CREATE_BUTTON',
    /**
     * @value New Adaptive Card
     * @description The title of the Adaptive Card creation dialog.
     *
     * ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    AC_CREATION_TITLE = 'PAGE.MICROAPP.AC_CREATION_TITLE',
    /**
     * @value Design your application interface in Adaptive Cards designer
     * @description The description for the design block within the Adaptive Card creation form.
     *
     * ⚠️ Please do not translate the “Microsoft Adaptive Cards” term, it should remain in English.
     */
    AC_DESIGN_DESC = 'PAGE.MICROAPP.AC_DESIGN_DESC',
    /**
     * @value Design
     * @description The title for the “Design” block within the Adaptive Card creation form.
     */
    AC_DESIGN_TITLE = 'PAGE.MICROAPP.AC_DESIGN_TITLE',
    /**
     * @value Edit Adaptive Card
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    AC_EDITION_TITLE = 'PAGE.MICROAPP.AC_EDITION_TITLE',
    /**
     * @value Data retrieved from previous API calls. Changes will not affect deployment.
     */
    AC_EXECUTION_CONTEXT_DESCRIPTION = 'PAGE.MICROAPP.AC_EXECUTION_CONTEXT_DESCRIPTION',
    /**
     * @value Execution context
     */
    AC_EXECUTION_CONTEXT_TITLE = 'PAGE.MICROAPP.AC_EXECUTION_CONTEXT_TITLE',
    /**
     * @value The name is only visible in the Micro-apps builder.
     * @description This is a short helper message for the name field within the Adaptive Card creation form.
     *
     * ⚠️ Please do not translate the “MicroApps” term, it should remain in English.
     */
    AC_NAME_HELPER = 'PAGE.MICROAPP.AC_NAME_HELPER',
    /**
     * @value Preview in Lumapps.
     */
    AC_PREVIEW_DESCRIPTION = 'PAGE.MICROAPP.AC_PREVIEW_DESCRIPTION',
    /**
     * @value Correct Adaptive Card structure errors to get a preview
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    AC_PREVIEW_ERROR_MESSAGE = 'PAGE.MICROAPP.AC_PREVIEW_ERROR_MESSAGE',
    /**
     * @value Preview is not available
     */
    AC_PREVIEW_NOT_AVAILABLE = 'PAGE.MICROAPP.AC_PREVIEW_NOT_AVAILABLE',
    /**
     * @value Card preview in Lumapps will be displayed here.
     */
    AC_PREVIEW_NOT_AVAILABLE_MESSAGE = 'PAGE.MICROAPP.AC_PREVIEW_NOT_AVAILABLE_MESSAGE',
    /**
     * @value Adaptive Card preview
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    AC_PREVIEW_TITLE = 'PAGE.MICROAPP.AC_PREVIEW_TITLE',
    /**
     * @value Structure code (JSON) retrieved from
     */
    AC_STRUCTURE_DESCRIPTION = 'PAGE.MICROAPP.AC_STRUCTURE_DESCRIPTION',
    /**
     * @value Adaptive Card structure
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    AC_STRUCTURE_TITLE = 'PAGE.MICROAPP.AC_STRUCTURE_TITLE',
    /**
     * @value Adaptive Cards designer
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    ADAPTIVE_CARDS_DESIGNER = 'PAGE.MICROAPP.ADAPTIVE_CARDS_DESIGNER',
    /**
     * @value Adaptive Card created
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    ADAPTIVE_CARD_CREATED = 'MICROAPP.ADAPTIVE_CARD_CREATED',
    /**
     * @value Adaptive card
     */
    ADAPTIVE_CARD_DESCRIPTION = 'PAGE.MICROAPP_DIALOG.ADAPTIVE_CARD_DESCRIPTION',
    /**
     * @value Adaptive Card renamed
     */
    ADAPTIVE_CARD_RENAMED = 'PAGE.MICROAPP.RENAME_ACTION_DIALOG.ADAPTIVE_CARD_RENAMED',
    /**
     * @value Adaptive Card saved
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    ADAPTIVE_CARD_SAVED = 'MICROAPP.ADAPTIVE_CARD_SAVED',
    /**
     * @value Adaptive Card
     */
    ADD_ADAPTIVE_CARD_ACTION = 'PAGE.MICROAPP_DIALOG.ADD_ADAPTIVE_CARD_ACTION',
    /**
     * @value API Call
     */
    ADD_API_ACTION = 'PAGE.MICROAPP_DIALOG.ADD_API_ACTION',
    /**
     * @value Add a filter
     */
    ADD_FILTER = 'MICROAPP.ADD_FILTER',
    /**
     * @value Add input variable
     */
    ADD_INPUT_VARIABLE = 'PAGE.MICROAPP_ACTION_DIALOG.ADD_INPUT_VARIABLE',
    /**
     * @value Loop
     */
    ADD_ITERATOR_ACTION = 'MICROAPP.ADD_ITERATOR_ACTION',
    /**
     * @value Router
     */
    ADD_ROUTER_ACTION = 'PAGE.MICROAPP_DIALOG.ADD_ROUTER_ACTION',
    /**
     * @value Add a value
     */
    ADD_VALUE = 'PAGE.MICROAPP_ACTION_DIALOG.ADD_VALUE',
    /**
     * @value Add variable
     */
    ADD_VARIABLE = 'MICROAPP.ADD_VARIABLE',
    /**
     * @value Allowed file types
     * @description Label for allowed file type selection of uploader component
     */
    ALLOWED_FILE_TYPE_LABEL = 'MICROAPP.ALLOWED_FILE_TYPE',
    /**
     * @value Select types
     * @description Placeholder for allowed file types selector of uploader component
     */
    ALLOWED_FILE_TYPE_PLACEHOLDER = 'MICROAPP.ALLOWED_FILE_TYPE_PLACEHOLDER',
    /**
     * @value API call
     */
    API_ACTION_DESCRIPTION = 'PAGE.MICROAPP_DIALOG.API_ACTION_DESCRIPTION',
    /**
     * @value Api call created
     */
    API_CALL_CREATED = 'MICROAPP.API_CALL_CREATED',
    /**
     * @value Request call failed.
     */
    API_CALL_FAILED = 'MICROAPP.ACTION.API_CALL_FAILED',
    /**
     * @value API call renamed
     */
    API_CALL_RENAMED = 'PAGE.MICROAPP.RENAME_ACTION_DIALOG.API_CALL_RENAMED',
    /**
     * @value Api call saved
     */
    API_CALL_SAVED = 'MICROAPP.API_CALL_SAVED',
    /**
     * @value Request call successful.
     */
    API_CALL_SUCCESS = 'MICROAPP.ACTION.API_CALL_SUCCESS',
    /**
     * @value Ask AI answer successfully created.
     */
    ASK_RESPONSE_CREATED = 'MICROAPP.ASK_RESPONSE_CREATED',
    /**
     * @value Ask AI answer
     */
    ASK_RESPONSE_DESCRIPTION = 'MICROAPP.ASK_RESPONSE_DESCRIPTION',
    /**
     * @value Ask AI answer successfully edited.
     */
    ASK_RESPONSE_EDITED = 'MICROAPP.ASK_RESPONSE_EDITED',
    /**
     * @value Allow user to map agent response to Ask AI answer.
     */
    ASK_RESPONSE_LUMAPPS_COMPONENT_DESCRIPTION = 'MICROAPP.ASK_RESPONSE_LUMAPPS_COMPONENT_DESCRIPTION',
    /**
     * @value Fill the Main source path first
     */
    ASK_RESPONSE_SOURCES_HELPER = 'MICROAPP.ASK_RESPONSE_SOURCES_HELPER',
    /**
     * @value Main source path
     */
    ASK_RESPONSE_SOURCES_MAIN_PATH = 'MICROAPP.ASK_RESPONSE_SOURCES_MAIN_PATH',
    /**
     * @value Body
     */
    BODY = 'PAGE.MICROAPP_ACTION_DIALOG.BODY',
    /**
     * @value Collapse execution context
     * @description tooltip label for the execution context expand/collapse button in adaptive card dialog
     */
    COLLAPSE_EXECUTION_CONTEXT = 'MICROAPP.COLLAPSE_EXECUTION_CONTEXT',
    /**
     * @value <b>Translate after setup is complete</b><br/>We recommend translating content once the Micro-App is finished and connected.
     * @description custom overview helper inside the translation dialog of micro apps
     */
    COMPLETED_TRANSLATIONS = 'MICROAPP.COMPLETED_TRANSLATIONS',
    /**
     * @value Micro-app cannot be imported if actions have been added. The current workflow will be deleted.
     * @description DO NOT TRANSLATE MICRO-APP, IT IS A PRODUCT NAME
     */
    CONFIRMATION_IMPORT_HELPER = 'MICROAPP.CONFIRMATION_IMPORT_HELPER',
    /**
     * @value Import micro-app?
     * @description DO NOT TRANSLATE MICRO-APP, IT IS A PRODUCT NAME
     */
    CONFIRMATION_IMPORT_TITLE = 'MICROAPP.CONFIRMATION_IMPORT_TITLE',
    /**
     * @value Current URL
     */
    CONTEXT_CURRENT_URL = 'MICROAPP.CONTEXT_CURRENT_URL',
    /**
     * @value currentUrl gets the URL where the Micro App is
     * @description "currentUrl" should not be translated
     */
    CONTEXT_CURRENT_URL_HELPER = 'MICROAPP.CONTEXT_CURRENT_URL_HELPER',
    /**
     * @value Resource ID
     */
    CONTEXT_RESOURCE_ID = 'MICROAPP.CONTEXT_RESOURCE_ID',
    /**
     * @value resourceId gets the ID of the resource where the Micro App is
     * @description "resourceId" should not be translated
     */
    CONTEXT_RESOURCE_ID_HELPER = 'MICROAPP.CONTEXT_RESOURCE_ID_HELPER',
    /**
     * @value Resource type
     */
    CONTEXT_RESOURCE_TYPE = 'MICROAPP.CONTEXT_RESOURCE_TYPE',
    /**
     * @value resourceType gets the type of resource where the Micro App is running. Possible values: "content" or "space".
     * @description Helper text for the Resource Type context variable field in the micro-app builder. "resourceType", "content" and "space" should not be translated.
     */
    CONTEXT_RESOURCE_TYPE_HELPER = 'MICROAPP.CONTEXT_RESOURCE_TYPE_HELPER',
    /**
     * @value Site ID
     */
    CONTEXT_SITE_ID = 'MICROAPP.CONTEXT_SITE_ID',
    /**
     * @value siteId gets the ID of the site where the Micro App is
     * @description "siteId" should not be translated
     */
    CONTEXT_SITE_ID_HELPER = 'MICROAPP.CONTEXT_SITE_ID_HELPER',
    /**
     * @value Context variables
     */
    CONTEXT_VARIABLES = 'MICROAPP.CONTEXT_VARIABLES',
    /**
     * @value You can select one or more variables to fetch data from where the Micro App is displayed.
     */
    CONTEXT_VARIABLE_CAPTION = 'MICROAPP.CONTEXT_VARIABLE_CAPTION',
    /**
     * @value Easily tailor your micro app content to where and how it’s displayed. By adding context variables, you can use JavaScript to dynamically show relevant information and create a smoother, more efficient user experience.
     */
    CONTEXT_VARIABLE_DESCRIPTION = 'MICROAPP.CONTEXT_VARIABLE_DESCRIPTION',
    /**
     * @value Add a specific value for this variable
     */
    CONTEXT_VARIABLE_PLACEHOLDER = 'MICROAPP.CONTEXT_VARIABLE_PLACEHOLDER',
    /**
     * @value Select variables you wish to use
     */
    CONTEXT_VARIABLE_SUBTITLE = 'MICROAPP.CONTEXT_VARIABLE_SUBTITLE',
    /**
     * @value New API call
     * @description Modal title for api call creation
     */
    CREATE_API_ACTION = 'PAGE.MICROAPP_ACTION_DIALOG.CREATE_API_ACTION',
    /**
     * @value New Ask AI answer
     */
    CREATE_ASK_RESPONSE_ACTION = 'MICROAPP.CREATE_ASK_RESPONSE_ACTION',
    /**
     * @value Create a new connector
     * @description Action to create a new connector
     */
    CREATE_CONNECTOR = 'PAGE.MICROAPP_ACTION_DIALOG.CREATE_CONNECTOR',
    /**
     * @value New file list
     */
    CREATE_FILE_LIST_COMPONENT = 'MICROAPP.CREATE_FILE_LIST_COMPONENT',
    /**
     * @value New media upload
     * @description Title for Lumapps component file upload creation dialog
     */
    CREATE_FILE_UPLOAD_COMPONENT = 'MICROAPP.CREATE_FILE_UPLOAD_COMPONENT',
    /**
     * @value Create JS Function
     * @description Dialog title for creation of JS Function action
     */
    CREATE_FUNCTION = 'MICROAPP.CREATE_FUNCTION',
    /**
     * @value %LANG% (default)
     * @description %lang% corresponding to the default language, in the translated select
     * (e.g: English (default)
     */
    DEFAULT_LANGUAGE_SELECTION = 'MICROAPP.DEFAULT_LANGUAGE_SELECTION',
    /**
     * @value Default value used if a value is not set.
     */
    DEFAULT_VALUE_HELPER = 'PAGE.MICROAPP_ACTION_DIALOG.DEFAULT_VALUE_HELPER',
    /**
     * @value Default value
     */
    DEFAULT_VALUE_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.DEFAULT_VALUE_LABEL',
    /**
     * @value Add a default value
     */
    DEFAULT_VALUE_PLACEHOLDER = 'PAGE.MICROAPP_ACTION_DIALOG.DEFAULT_VALUE_PLACEHOLDER',
    /**
     * @value Delete adaptive card?
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    DELETE_ADAPTIVE_CARD = 'PAGE.MICROAPP.DELETE_ADAPTIVE_CARD_DIALOG.TITLE',
    /**
     * @value Deleting the adaptive card is irreversible. You will delete the entire configuration.
     * @description ⚠️ Please do not translate the “Adaptive Card” term, it should remain in English.
     */
    DELETE_ADAPTIVE_CARD_MESSAGE = 'PAGE.MICROAPP.DELETE_ADAPTIVE_CARD_DIALOG.MESSAGE',
    /**
     * @value Delete API call?
     */
    DELETE_API_CALL = 'PAGE.MICROAPP.DELETE_API_ACTION_DIALOG.TITLE',
    /**
     * @value Deleting the API call is irreversible. You will delete the entire configuration.
     */
    DELETE_API_CALL_MESSAGE = 'PAGE.MICROAPP.DELETE_API_ACTION_DIALOG.MESSAGE',
    /**
     * @value Delete Ask AI answer?
     */
    DELETE_ASK_RESPONSE = 'MICROAPP.DELETE_ASK_RESPONSE',
    /**
     * @value Deleting the Ask AI answer is irreversible. You will delete the entire configuration.
     */
    DELETE_ASK_RESPONSE_MESSAGE = 'MICROAPP.DELETE_ASK_RESPONSE_MESSAGE',
    /**
     * @value Delete JS Function?
     * @description Delete function dialog title
     */
    DELETE_FUNCTION = 'MICROAPP.DELETE_FUNCTION',
    /**
     * @value Deleting the JS function is irreversible. You will delete the entire configuration.
     */
    DELETE_FUNCTION_MESSAGE = 'MICROAPP.DELETE_FUNCTION_MESSAGE',
    /**
     * @value Delete iterator?
     */
    DELETE_GROUP = 'MICROAPP.DELETE_ITERATOR',
    /**
     * @value Deleting the iterator is irreversible. You will delete the entire configuration.
     */
    DELETE_GROUP_MESSAGE = 'MICROAPP.DELETE_ITERATOR_MESSAGE',
    /**
     * @value Delete LumApps component
     * @description Delete lumapps component dialog title
     */
    DELETE_LUMAPPS_COMPONENT = 'MICROAPP.DELETE_LUMAPPS_COMPONENT',
    /**
     * @value Deleting the LumApps component is irreversible. You will delete the entire configuration.
     * @description Delete lumapps component dialog message
     */
    DELETE_LUMAPPS_COMPONENT_MESSAGE = 'MICROAPP.DELETE_LUMAPPS_COMPONENT_MESSAGE',
    /**
     * @value Delete Router?
     */
    DELETE_ROUTER = 'MICROAPP.DELETE_ROUTER',
    /**
     * @value Deleting the Router is irreversible.
     */
    DELETE_ROUTER_MESSAGE = 'MICROAPP.DELETE_ROUTER_MESSAGE',
    /**
     * @value Describe the value that is expected from the administrator or end user for this input.
     */
    DESCRIPTION_HELPER = 'PAGE.MICROAPP_ACTION_DIALOG.DESCRIPTION_HELPER',
    /**
     * @value Add a description
     */
    DESCRIPTION_PLACEHOLDER = 'PAGE.MICROAPP_ACTION_DIALOG.DESCRIPTION_PLACEHOLDER',
    /**
     * @value Design Micro-app
     */
    DESIGN_MICROAPP = 'PAGE.EXTENSION_MODAL.DESIGN_MICROAPP',
    /**
     * @value Discard changes
     */
    DISCARD_CHANGES = 'PAGE.MICROAPP_ACTION_DIALOG.DISCARD_CHANGES',
    /**
     * @value Your recent changes are not saved. If you leave now, changes will be lost.
     */
    DISCARD_MESSAGE = 'PAGE.MICROAPP_ACTION_DIALOG.DISCARD_MESSAGE',
    /**
     * @value Discard changes?
     */
    DISCARD_TITLE = 'PAGE.MICROAPP_ACTION_DIALOG.DISCARD_TITLE',
    /**
     * @value Display in translated language
     * @description label of available translation select in run drawer
     */
    DISPLAY_TRANSLATED_LANGUAGE = 'MICROAPP.DISPLAY_TRANSLATED_LANGUAGE',
    /**
     * @value Identifier already exists on another input variable. Add a unique identifier.
     * @description Error message for duplicated identifier.
     */
    DUPLICATE_IDENTIFIER = 'MICROAPP.DUPLICATE_INPUT_VARIABLE_IDENTIFIER',
    /**
     * @value Edit API Call
     */
    EDIT_API_ACTION = 'PAGE.MICROAPP_ACTION_DIALOG.EDIT_API_ACTION',
    /**
     * @value Edit Ask AI answer
     */
    EDIT_ASK_RESPONSE_ACTION = 'MICROAPP.EDIT_ASK_RESPONSE_ACTION',
    /**
     * @value Edit file list
     */
    EDIT_FILE_LIST_COMPONENT = 'MICROAPP.EDIT_FILE_LIST_COMPONENT',
    /**
     * @value Edit media upload
     */
    EDIT_FILE_UPLOAD_COMPONENT = 'MICROAPP.EDIT_FILE_UPLOAD_COMPONENT',
    /**
     * @value Edit JS Function
     * @description Edit JS function dialog title
     */
    EDIT_FUNCTION = 'MICROAPP.EDIT_FUNCTION',
    /**
     * @value Edit iterator
     */
    EDIT_ITERATOR = 'MICROAPP.EDIT_ITERATOR',
    /**
     * @value Edit loop
     */
    EDIT_LOOP = 'MICROAPP.EDIT_LOOP',
    /**
     * @value Edit Micro-app
     * @description DO NOT TRANSLATE MICRO-APP, IT IS A PRODUCT NAME.
     * Label of a button that lets the user know that clicking it will open the "form" to edit the micro-app
     */
    EDIT_MICROAPP = 'PAGE.MICROAPP.EDIT_MICROAPP',
    /**
     * @value Edit start inputs
     */
    EDIT_START_INPUTS = 'PAGE.MICROAPP.EDIT_START_INPUTS',
    /**
     * @value Edit input variables
     */
    EDIT_TRIGGER_ACTION = 'PAGE.MICROAPP_ACTION_DIALOG.EDIT_TRIGGER_ACTION',
    /**
     * @value Input variables allows administrators or end users to add personalized values to the input fields you configure. The input is added to the execution context.
     */
    EDIT_TRIGGER_ACTION_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.EDIT_TRIGGER_ACTION_DESCRIPTION',
    /**
     * @value Send request
     */
    EMPTY_RESPONSE_BUTTON = 'PAGE.MICROAPP_ACTION_DIALOG.EMPTY_RESPONSE_BUTTON',
    /**
     * @value Click the "Send request" button to display the API call response.
     */
    EMPTY_RESPONSE_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.EMPTY_RESPONSE_DESCRIPTION',
    /**
     * @value Response will be displayed here.
     */
    EMPTY_RESPONSE_TITLE = 'PAGE.MICROAPP_ACTION_DIALOG.EMPTY_RESPONSE_TITLE',
    /**
     * @value path must start with /
     */
    ENDPOINT_PATH_HELPER = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_PATH_HELPER',
    /**
     * @value Enter a valid path
     */
    ENDPOINT_PATH_INVALID = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_PATH_INVALID',
    /**
     * @value Endpoint path
     */
    ENDPOINT_PATH_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_PATH_LABEL',
    /**
     * @value Path is required
     */
    ENDPOINT_PATH_REQUIRED = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_PATH_REQUIRED',
    /**
     * @value url must start with http(s):// or ${.*)
     */
    ENDPOINT_URL_HELPER = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_URL_HELPER',
    /**
     * @value Enter a valid url
     */
    ENDPOINT_URL_INVALID = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_URL_INVALID',
    /**
     * @value Endpoint url
     * @description Label of enpoint form field
     */
    ENDPOINT_URL_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_URL_LABEL',
    /**
     * @value Url is required
     */
    ENDPOINT_URL_REQUIRED = 'PAGE.MICROAPP_ACTION_DIALOG.ENDPOINT_URL_REQUIRED',
    /**
     * @value Expand execution context
     * @description tooltip label for the execution context expand/collapse button in adaptive card dialog
     */
    EXPAND_EXECUTION_CONTEXT = 'MICROAPP.EXPAND_EXECUTION_CONTEXT',
    /**
     * @value Export micro-app
     * @description DO NOT TRANSLATE MICRO-APP, IT IS A PRODUCT NAME
     */
    EXPORT_MICRO_APP = 'MICROAPP.EXPORT_MICRO_APP',
    /**
     * @value Configure API calls by editing them, selecting a connector (if required), and running a test to complete the setup.
     */
    EXTENDED_NOTIFICATION_CONTENT = 'MICROAPP.EXTENDED_NOTIFICATION_CONTENT',
    /**
     * @value Configure API calls
     */
    EXTENDED_NOTIFICATION_TITLE = 'MICROAPP.EXTENDED_NOTIFICATION_TITLE',
    /**
     * @value Authorized actions on files:
     */
    FILE_LIST_AUTHORIZED_ACTIONS_LABEL = 'MICROAPP.FILE_LIST_AUTHORIZED_ACTIONS_LABEL',
    /**
     * @value File list
     */
    FILE_LIST_COMPONENT = 'WIDGET_TYPE_FILE-LIST',
    /**
     * @value Display files and folder from storage service providers.
     */
    FILE_LIST_COMPONENT_DESCRIPTION = 'MICROAPP.FILE_LIST_COMPONENT_DESCRIPTION',
    /**
     * @value File list component edition steps
     */
    FILE_LIST_COMPONENT_STEPS = 'MICROAPP.FILE_LIST_STEPS',
    /**
     * @value Edit description
     */
    FILE_LIST_EDIT_DESCRIPTION_OPTION_LABEL = 'MICROAPP.FILE_LIST_EDIT_DESCRIPTION_OPTION_LABEL',
    /**
     * @value File Upload
     * @description file upload component name
     */
    FILE_UPLOAD_COMPONENT = 'MICROAPP.FILE_UPLOAD',
    /**
     * @value Allow user to upload files.
     * @description Description for file upload lumapps component
     */
    FILE_UPLOAD_COMPONENT_DESCRIPTION = 'MICROAPP.FILE_UPLOAD_DESCRIPTION',
    /**
     * @value JavaScript
     */
    FUNCTION_ACTION_DESCRIPTION = 'PAGE.MICROAPP_DIALOG.FUNCTION_ACTION_DESCRIPTION',
    /**
     * @value JS Function renamed
     * @description Toast notification after renamed a JS function action in micro-apps
     */
    FUNCTION_RENAMED = 'MICROAPP.FUNCTION_RENAMED',
    /**
     * @value The function code exceeds the maximum allowed size of {maxSize} KB.
     * @description Error message shown in the function action editor when the JS code exceeds the size limit
     */
    FUNCTION_SOURCE_TOO_LARGE = 'MICROAPP.FUNCTION_SOURCE_TOO_LARGE',
    /**
     * @value Function
     */
    FUNCTION_TITLE = 'PAGE.MICROAPP_ACTION_DIALOG.FUNCTION_TITLE',
    /**
     * @value Failed to fetch translations
     * @description Let the user know if an error occur during the translation fetching (either by clicking on "Translate/Manage translation" or on "Run micro app" button
     */
    GET_TRANSLATION_ERROR = 'MICROAPP.GET_TRANSLATION_ERROR',
    /**
     * @value Google Drive
     */
    GOOGLE_DRIVE = 'MICROAPP.GOOGLE_DRIVE',
    /**
     * @value Back button link
     */
    GO_BACK_HANDLE_TOOLTIP = 'MICROAPP.GO_BACK_HANDLE_TOOLTIP',
    /**
     * @value Headers
     */
    HEADERS = 'PAGE.MICROAPP_ACTION_DIALOG.HEADERS',
    /**
     * @value This header is not allowed
     */
    HEADER_NOT_ALLOWED = 'PAGE.MICROAPP_ACTION_DIALOG.HEADER_NOT_ALLOWED',
    /**
     * @value History
     */
    HISTORY = 'PAGE.MICROAPP_DIALOG.HISTORY',
    /**
     * @value Valid characters: lowercase letters, numbers, the hyphen "-" and underscore "_" characters.
     */
    IDENTIFIER_HELPER = 'PAGE.MICROAPP_ACTION_DIALOG.IDENTIFIER_HELPER',
    /**
     * @value Identifier
     */
    IDENTIFIER_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.IDENTIFIER_LABEL',
    /**
     * @value Add an identifier
     */
    IDENTIFIER_PLACEHOLDER = 'PAGE.MICROAPP_ACTION_DIALOG.IDENTIFIER_PLACEHOLDER',
    /**
     * @value Access permission
     */
    IFRAME_ACCESS_PERMISSION_LABEL = 'MICROAPP.IFRAME_ACCESS_PERMISSION_LABEL',
    /**
     * @value Permission
     */
    IFRAME_ADD_PERMISSION = 'MICROAPP.IFRAME_ADD_PERMISSION',
    /**
     * @value Format your message payload using the specifications below. Correct formatting allows the micro-app to process your data and trigger the right actions.
     */
    IFRAME_ADD_SNIPPET_DESCRIPTION = 'MICROAPP.IFRAME_ADD_SNIPPET_DESCRIPTION',
    /**
     * @value Add snippet
     */
    IFRAME_ADD_SNIPPET_TITLE = 'MICROAPP.IFRAME_ADD_SNIPPET_TITLE',
    /**
     * @value Advanced settings
     */
    IFRAME_ADVANCED_SETTINGS = 'MICROAPP.IFRAME_ADVANCED_SETTINGS',
    /**
     * @value Basic settings
     */
    IFRAME_BASIC_SETTINGS = 'MICROAPP.IFRAME_BASIC_SETTINGS',
    /**
     * @value Iframe
     * @description Iframe source for search settings
     */
    IFRAME_COMPONENT = 'SEARCH_SETTINGS.IFRAME_SOURCE_TITLE',
    /**
     * @value Load an embedded content from an Iframe
     */
    IFRAME_COMPONENT_DESCRIPTION = 'MICROAPP.IFRAME_DESCRIPTION',
    /**
     * @value Copy Close button snippet
     */
    IFRAME_COPY_CLOSE_SNIPPET = 'MICROAPP.IFRAME_COPY_CLOSE_SNIPPET',
    /**
     * @value Copy Next button snippet
     */
    IFRAME_COPY_NEXT_SNIPPET = 'MICROAPP.IFRAME_COPY_NEXT_SNIPPET',
    /**
     * @value Access to device hardware permissions
     */
    IFRAME_DEVICE_PERMISSIONS_LABEL = 'MICROAPP.IFRAME_DEVICE_PERMISSIONS_LABEL',
    /**
     * @value Device permissions are not available on the mobile native app.
     */
    IFRAME_DEVICE_PERMISSIONS_MOBILE_DISCLAIMER = 'MICROAPP.IFRAME_DEVICE_PERMISSIONS_MOBILE_DISCLAIMER',
    /**
     * @value Display settings
     */
    IFRAME_DISPLAY_SETTINGS = 'MICROAPP.IFRAME_DISPLAY_SETTINGS',
    /**
     * @value documentation
     * @description Link used in key https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=336583096
     */
    IFRAME_DOCUMENTATION = 'SEGMENT.PROPERTIES_MORE_INFO_LINK',
    /**
     * @value For more information, refer to the
     * @description a space should be present at the end of this sentence.
     */
    IFRAME_DOCUMENTATION_DESCRIPTION = 'ADMIN.PROVIDER.FOR_MORE_INFO_REFER_TO',
    /**
     * @value Your data is now in the context variables
     */
    IFRAME_EXECUTION_CONTEXT_UPDATED = 'MICROAPP.IFRAME_EXECUTION_CONTEXT_UPDATED',
    /**
     * @value Full screen mode
     */
    IFRAME_FULLSCREEN_MODE = 'MICROAPP.IFRAME_FULLSCREEN_MODE',
    /**
     * @value Height in pixels or %
     */
    IFRAME_HEIGHT_IN_PIXELS_OR_PERCENT = 'MICROAPP.IFRAME_HEIGHT_IN_PIXELS_OR_PERCENT',
    /**
     * @value Accelerometer
     */
    IFRAME_PERMISSION_ACCELEROMETER = 'MICROAPP.IFRAME_PERMISSION_ACCELEROMETER',
    /**
     * @value Ambient light sensor
     */
    IFRAME_PERMISSION_AMBIENT_LIGHT_SENSOR = 'MICROAPP.IFRAME_PERMISSION_AMBIENT_LIGHT_SENSOR',
    /**
     * @value Autoplay
     */
    IFRAME_PERMISSION_AUTOPLAY = 'MICROAPP.IFRAME_PERMISSION_AUTOPLAY',
    /**
     * @value Bluetooth
     */
    IFRAME_PERMISSION_BLUETOOTH = 'MICROAPP.IFRAME_PERMISSION_BLUETOOTH',
    /**
     * @value Camera
     */
    IFRAME_PERMISSION_CAMERA = 'MICROAPP.IFRAME_PERMISSION_CAMERA',
    /**
     * @value Clipboard read
     */
    IFRAME_PERMISSION_CLIPBOARD_READ = 'MICROAPP.IFRAME_PERMISSION_CLIPBOARD_READ',
    /**
     * @value Clipboard write
     */
    IFRAME_PERMISSION_CLIPBOARD_WRITE = 'MICROAPP.IFRAME_PERMISSION_CLIPBOARD_WRITE',
    /**
     * @value Encrypted media
     */
    IFRAME_PERMISSION_ENCRYPTED_MEDIA = 'MICROAPP.IFRAME_PERMISSION_ENCRYPTED_MEDIA',
    /**
     * @value Fullscreen
     */
    IFRAME_PERMISSION_FULLSCREEN = 'MICROAPP.IFRAME_PERMISSION_FULLSCREEN',
    /**
     * @value Gamepad
     */
    IFRAME_PERMISSION_GAMEPAD = 'MICROAPP.IFRAME_PERMISSION_GAMEPAD',
    /**
     * @value Geolocation
     */
    IFRAME_PERMISSION_GEOLOCATION = 'MICROAPP.IFRAME_PERMISSION_GEOLOCATION',
    /**
     * @value Gyroscope
     */
    IFRAME_PERMISSION_GYROSCOPE = 'MICROAPP.IFRAME_PERMISSION_GYROSCOPE',
    /**
     * @value HID (Human Interface Device)
     */
    IFRAME_PERMISSION_HID = 'MICROAPP.IFRAME_PERMISSION_HID',
    /**
     * @value Idle detection
     */
    IFRAME_PERMISSION_IDLE_DETECTION = 'MICROAPP.IFRAME_PERMISSION_IDLE_DETECTION',
    /**
     * @value Local fonts
     */
    IFRAME_PERMISSION_LOCAL_FONTS = 'MICROAPP.IFRAME_PERMISSION_LOCAL_FONTS',
    /**
     * @value Magnetometer
     */
    IFRAME_PERMISSION_MAGNETOMETER = 'MICROAPP.IFRAME_PERMISSION_MAGNETOMETER',
    /**
     * @value Microphone
     */
    IFRAME_PERMISSION_MICROPHONE = 'MICROAPP.IFRAME_PERMISSION_MICROPHONE',
    /**
     * @value MIDI
     */
    IFRAME_PERMISSION_MIDI = 'MICROAPP.IFRAME_PERMISSION_MIDI',
    /**
     * @value Payment
     */
    IFRAME_PERMISSION_PAYMENT = 'MICROAPP.IFRAME_PERMISSION_PAYMENT',
    /**
     * @value Picture in picture
     */
    IFRAME_PERMISSION_PICTURE_IN_PICTURE = 'MICROAPP.IFRAME_PERMISSION_PICTURE_IN_PICTURE',
    /**
     * @value WebAuthn (create credentials)
     */
    IFRAME_PERMISSION_PUBLICKEY_CREDENTIALS_CREATE = 'MICROAPP.IFRAME_PERMISSION_PUBLICKEY_CREDENTIALS_CREATE',
    /**
     * @value WebAuthn (get credentials)
     */
    IFRAME_PERMISSION_PUBLICKEY_CREDENTIALS_GET = 'MICROAPP.IFRAME_PERMISSION_PUBLICKEY_CREDENTIALS_GET',
    /**
     * @value Screen sharing
     */
    IFRAME_PERMISSION_SCREEN_SHARING = 'MICROAPP.IFRAME_PERMISSION_SCREEN_SHARING',
    /**
     * @value Screen wake lock
     */
    IFRAME_PERMISSION_SCREEN_WAKE_LOCK = 'MICROAPP.IFRAME_PERMISSION_SCREEN_WAKE_LOCK',
    /**
     * @value Serial
     */
    IFRAME_PERMISSION_SERIAL = 'MICROAPP.IFRAME_PERMISSION_SERIAL',
    /**
     * @value Speaker selection
     */
    IFRAME_PERMISSION_SPEAKER_SELECTION = 'MICROAPP.IFRAME_PERMISSION_SPEAKER_SELECTION',
    /**
     * @value Storage access
     */
    IFRAME_PERMISSION_STORAGE_ACCESS = 'MICROAPP.IFRAME_PERMISSION_STORAGE_ACCESS',
    /**
     * @value Access type
     */
    IFRAME_PERMISSION_TYPE = 'MICROAPP.IFRAME_PERMISSION_TYPE',
    /**
     * @value USB
     */
    IFRAME_PERMISSION_USB = 'MICROAPP.IFRAME_PERMISSION_USB',
    /**
     * @value Value
     */
    IFRAME_PERMISSION_VALUE = 'MICROAPP.IFRAME_PERMISSION_VALUE',
    /**
     * @value Web share
     */
    IFRAME_PERMISSION_WEB_SHARE = 'MICROAPP.IFRAME_PERMISSION_WEB_SHARE',
    /**
     * @value Window management
     */
    IFRAME_PERMISSION_WINDOW_MANAGEMENT = 'MICROAPP.IFRAME_PERMISSION_WINDOW_MANAGEMENT',
    /**
     * @value XR spatial tracking
     */
    IFRAME_PERMISSION_XR_SPATIAL_TRACKING = 'MICROAPP.IFRAME_PERMISSION_XR_SPATIAL_TRACKING',
    /**
     * @value iFrame content will be displayed here
     */
    IFRAME_PREVIEW_EMPTY_STATE = 'MICROAPP.IFRAME_PREVIEW_EMPTY_STATE',
    /**
     * @value Preview and interact with your iFrame content to see how it appears in the micro-app
     */
    IFRAME_PREVIEW_EMPTY_STATE_DESCRIPTION = 'MICROAPP.IFRAME_PREVIEW_EMPTY_STATE_DESCRIPTION',
    /**
     * @value Check your iFrame content to see how it looks within the micro-app. Interact with the iFrame content to send context variables to the builder.
     */
    IFRAME_PREVIEW_HELPER = 'MICROAPP.IFRAME_PREVIEW_HELPER',
    /**
     * @value Sandbox permissions
     */
    IFRAME_SANDBOX_PERMISSIONS_LABEL = 'MICROAPP.IFRAME_SANDBOX_PERMISSIONS_LABEL',
    /**
     * @value Add title
     */
    IFRAME_SETTINGS_ADD_TITLE = 'MICROAPP.IFRAME_SETTINGS_ADD_TITLE',
    /**
     * @value The iframe will automatically launch in full screen mode.
     */
    IFRAME_SETTINGS_DEFAULT_FULLSCREEN_HELPER = 'MICROAPP.IFRAME_SETTINGS_DEFAULT_FULLSCREEN_HELPER',
    /**
     * @value Allow full screen by default
     */
    IFRAME_SETTINGS_DEFAULT_FULLSCREEN_TITLE = 'MICROAPP.IFRAME_SETTINGS_DEFAULT_FULLSCREEN_TITLE',
    /**
     * @value Height
     */
    IFRAME_SETTINGS_HEIGHT = 'WIDGET_TYPE_IFRAME_SETTINGS_HEIGHT',
    /**
     * @value Add the height in pixels or % — like 100px or 100%
     */
    IFRAME_SETTINGS_HEIGHT_ERROR = 'MICROAPP.IFRAME_SETTINGS_HEIGHT_ERROR',
    /**
     * @value Provide the height in pixels or %
     */
    IFRAME_SETTINGS_HEIGHT_HELPER = 'MICROAPP.IFRAME_SETTINGS_HEIGHT_HELPER',
    /**
     * @value Header title
     */
    IFRAME_SETTINGS_TITLE = 'MICROAPP.IFRAME_SETTINGS_TITLE',
    /**
     * @value Create Iframe component
     */
    IFRAME_SETTINGS_TITLE_CREATE = 'MICROAPP.IFRAME_SETTINGS_TITLE_CREATE',
    /**
     * @value Edit Iframe component
     */
    IFRAME_SETTINGS_TITLE_EDIT = 'MICROAPP.IFRAME_SETTINGS_TITLE_EDIT',
    /**
     * @value Width
     */
    IFRAME_SETTINGS_WIDTH = 'WIDGET_TYPE_IFRAME_SETTINGS_WIDTH',
    /**
     * @value Add the width in pixels or % — like 100px or 100%
     */
    IFRAME_SETTINGS_WIDTH_ERROR = 'MICROAPP.IFRAME_SETTINGS_WIDTH_ERROR',
    /**
     * @value Snippet copied successfully to clipboard
     */
    IFRAME_SNIPPET_COPIED = 'MICROAPP.IFRAME_SNIPPET_COPIED',
    /**
     * @value Provide the source to display the content in the iFrame
     */
    IFRAME_URL_HELPER = 'MICROAPP.IFRAME_URL_HELPER',
    /**
     * @value Width in pixels or %
     */
    IFRAME_WIDTH_IN_PIXELS_OR_PERCENT = 'MICROAPP.IFRAME_WIDTH_IN_PIXELS_OR_PERCENT',
    /**
     * @value The JSON file contains an error or was modified. Upload failed.
     * @description helper to let the user know something's wrong with its json file
     */
    IMPORT_FAILED_HELPER = 'MICROAPP.IMPORT_FAILED_HELPER',
    /**
     * @value Import micro-app
     * @description DO NOT TRANSLATE MICRO-APP, IT IS A PRODUCT NAME
     */
    IMPORT_MICRO_APPS = 'MICROAPP.IMPORT_MICRO_APPS',
    /**
     * @value Failed to import translations.
     */
    IMPORT_TRANSLATIONS_FAILED = 'MICROAPP.IMPORT_TRANSLATIONS_FAILED',
    /**
     * @value The translations have been successfully imported.
     */
    IMPORT_TRANSLATIONS_SUCCEED = 'MICROAPP.IMPORT_TRANSLATIONS_SUCCEED',
    /**
     * @value Name of your micro-app
     * @description Placeholder of the extension title
     */
    INFORMATION_TITLE_PLACEHOLDER = 'MICROAPP.INFORMATION_TITLE_PLACEHOLDER',
    /**
     * @value Input variables
     */
    INPUT_VARIABLES = 'MICROAPP.INPUT_VARIABLES',
    /**
     * @value Input variable
     */
    INPUT_VARIABLE_TITLE = 'PAGE.MICROAPP_ACTION_DIALOG.INPUT_VARIABLE_TITLE',
    /**
     * @value Name your input variable
     */
    INPUT_VARIABLE_TITLE_PLACEHOLDER = 'MICROAPP.INPUT_VARIABLE_TITLE_PLACEHOLDER',
    /**
     * @value Interact with the interface below to run the micro-app.
     * @description Warning message displayed during run's micro-app step
     */
    INTERACT_WITH_INTERFACE = 'MICROAPP.INTERACT_WITH_INTERFACE',
    /**
     * @value Invalid character
     */
    INVALID_CHARACTER = 'PAGE.MICROAPP_ACTION_DIALOG.INVALID_CHARACTER',
    /**
     * @value Close keyboard shortcuts
     */
    KEYBOARD_SHORTCUTS_CLOSE = 'MICROAPP.KEYBOARD_SHORTCUTS_CLOSE',
    /**
     * @value Keyboard shortcuts
     */
    KEYBOARD_SHORTCUTS_TITLE = 'MICROAPP.KEYBOARD_SHORTCUTS_TITLE',
    /**
     * @value Last saved on %DATE%
     * @description MicroApp subtitle to display last saved date
     */
    LAST_SAVED_ON = 'PAGE.MICROAPP_DIALOG.LAST_SAVED_ON',
    /**
     * @value LumApps Component
     * @description Any Micro App Lumapps Component reference
     */
    LUMAPPS_COMPONENT = 'MICROAPP.LUMAPPS_COMPONENT',
    /**
     * @value LumApps component created
     * @description Confirmation of successful lumapps component creation
     */
    LUMAPPS_COMPONENT_CREATED = 'MICROAPP.LUMAPPS_COMPONENT_CREATED',
    /**
     * @value LumApps component saved
     */
    LUMAPPS_COMPONENT_SAVED = 'MICROAPP.LUMAPPS_COMPONENT_SAVED',
    /**
     * @value User will not be able to skip upload step.
     * @description Description for the option to set uploader component as required
     */
    MANDATORY_FILE_UPLOAD_OPTION_DESCRIPTION = 'MICROAPP.MANDATORY_FILE_UPLOAD_DESCRIPTION',
    /**
     * @value File upload is mandatory
     * @description Title for the option to set uploader component as required
     */
    MANDATORY_FILE_UPLOAD_OPTION_TITLE = 'MICROAPP.MANDATORY_FILE_UPLOAD_TITLE',
    /**
     * @value Maximum file size
     * @description Label for the max file size field of lumapps component
     */
    MAXIMUM_FILE_SIZE_LABEL = 'MICROAPP.MAXIMUM_FILE_SIZE_LABEL',
    /**
     * @value Enter file size in MB.
     * @description Placeholder for max file size field
     */
    MAXIMUM_FILE_SIZE_PLACEHOLDER = 'MICROAPP.MAXIMUM_FILE_SIZE_PLACEHOLDER',
    /**
     * @value Method
     */
    METHOD_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.METHOD_LABEL',
    /**
     * @value Micro-app exported
     * @description DO NOT TRANSLATE MICRO-APP, IT IS A PRODUCT NAME
     *
     * success toaster
     */
    MICRO_APP_EXPORTED = 'MICROAPP.MICRO_APP_EXPORTED',
    /**
     * @value Micro-app imported correctly
     * @description DO NOT TRANSLATE MICRO-APP, IT IS A PRODUCT NAME
     *
     * success toaster
     */
    MICRO_APP_IMPORTED = 'MICROAPP.MICRO_APP_IMPORTED',
    /**
     * @value The name is only visible in the Micro-app builder.
     */
    NAME_HINT = 'PAGE.MICROAPP_ACTION_DIALOG.NAME_HINT',
    /**
     * @value New filter
     */
    NEW_FILTER = 'MICROAPP.NEW_FILTER',
    /**
     * @value New iterator
     */
    NEW_ITERATOR = 'MICROAPP.NEW_ITERATOR',
    /**
     * @value New loop
     */
    NEW_LOOP = 'MICROAPP.NEW_LOOP',
    /**
     * @value if the targeted provider is not in the list.
     * @description New provider description
     */
    NEW_PROVIDER_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.NEW_PROVIDER_DESCRIPTION',
    /**
     * @value New provider
     * @description New provider title
     */
    NEW_PROVIDER_TITLE = 'PAGE.MICROAPP_ACTION_DIALOG.NEW_PROVIDER_TITLE',
    /**
     * @value You will create a new version of this Micro-app. Are you sure?
     */
    NEW_VERSION_MESSAGE = 'PAGE.NEW_MICROAPP_VERSION.MESSAGE',
    /**
     * @value This should be a positive number.
     */
    NO_NEGATIVE_NUMBER_ERROR = 'MICROAPP.NO_NEGATIVE_NUMBER_ERROR',
    /**
     * @value Perform a test of your JS Action to display results here
     */
    NO_TEST_RESULT_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.NO_TEST_RESULT_DESCRIPTION',
    /**
     * @value No test result yet
     */
    NO_TEST_RESULT_TITLE = 'PAGE.MICROAPP_ACTION_DIALOG.NO_TEST_RESULT_TITLE',
    /**
     * @value Open designer
     */
    OPEN_DESIGNER = 'MICROAPP.OPEN_DESIGNER',
    /**
     * @value Parameters
     */
    PARAMETERS = 'PAGE.MICROAPP_ACTION_DIALOG.PARAMETERS',
    /**
     * @value Answer preview in Ask AI.
     */
    PREVIEW_ASK_RESPONSE = 'MICROAPP.PREVIEW_ASK_RESPONSE',
    /**
     * @value Preview is displayed here.
     */
    PREVIEW_DISPLAYED = 'MICROAPP.PREVIEW_DISPLAYED',
    /**
     * @value Add required values to preview answer.
     */
    PREVIEW_REQUIRED_VALUES = 'MICROAPP.PREVIEW_REQUIRED_VALUES',
    /**
     * @value Generate a micro-app
     */
    PROMPT_DIALOG_TITLE = 'MICROAPP.GENERATE_MICROAPP_DIALOG_TITLE',
    /**
     * @value Edit prompt
     */
    PROMPT_EDIT = 'MICROAPP.GENERATE_MICROAPP_PROMPT_EDIT',
    /**
     * @value Public API (Unauthenticated)
     * @description Public provider for microapp api call
     */
    PUBLIC_API = 'PAGE.MICROAPP_ACTION_DIALOG.PUBLIC_API',
    /**
     * @value Query parameters
     */
    QUERY_PARAMETERS = 'PAGE.MICROAPP_ACTION_DIALOG.QUERY_PARAMETERS',
    /**
     * @value This version cannot be edited. No changes can be saved.
     * @description Warning message to alert user is in readonly mode
     */
    READONLY_MESSAGE = 'MICROAPP.READONLY_MESSAGE',
    /**
     * @value This will be your default source language for managing translations.
     * @description custom reference language information for the confirmation dialog during the translation flow inside the micro apps builder
     */
    REFERENCE_LANGUAGE = 'MICROAPP.REFERENCE_LANGUAGE',
    /**
     * @value Rename Adaptive Card
     */
    RENAME_ADAPTIVE_CARD = 'PAGE.MICROAPP.RENAME_ACTION_DIALOG.ADAPTIVE_CARD',
    /**
     * @value Rename API call
     */
    RENAME_API_CALL = 'PAGE.MICROAPP.RENAME_ACTION_DIALOG.API_CALL',
    /**
     * @value Rename Ask AI answer
     */
    RENAME_ASK_RESPONSE = 'MICROAPP.RENAME_ASK_RESPONSE',
    /**
     * @value Rename JS Function
     * @description dialog title to rename a JS function action in micro-apps.
     */
    RENAME_FUNCTION = 'MICROAPP.RENAME_FUNCTION',
    /**
     * @value Rename iterator
     * @description Rename iterator dialog title
     */
    RENAME_GROUP = 'MICROAPP.RENAME_ITERATOR',
    /**
     * @value Rename LumApps component
     * @description Rename lumapps component dialog title
     */
    RENAME_LUMAPPS_COMPONENT = 'MICROAPP.RENAME_LUMAPPS_COMPONENT',
    /**
     * @value Request
     */
    REQUEST_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.REQUEST_LABEL',
    /**
     * @value Make the input required to ensure that the value is set before the micro-app is run.
     */
    REQUIRED_INPUT_VARIABLE_HELPER = 'MICROAPP.REQUIRED_INPUT_VARIABLE_HELPER',
    /**
     * @value Input variable is required
     */
    REQUIRED_INPUT_VARIABLE_LABEL = 'MICROAPP.REQUIRED_INPUT_VARIABLE_LABEL',
    /**
     * @value Response
     */
    RESPONSE_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.RESPONSE_LABEL',
    /**
     * @value Operator
     */
    ROUTER_ACTION = 'PAGE.MICROAPP.CREATE_FILTER.OPERATOR',
    /**
     * @value Router action
     */
    ROUTER_ACTION_LABEL = 'PAGE.MICROAPP_DIALOG.ROUTER_ACTION_LABEL',
    /**
     * @value Run
     */
    RUN = 'MICROAPP.RUN',
    /**
     * @value An action is disconnected from the main flow and will be ignored when running the micro-app.
     * @description “Run” or "Run micro-app" is the feature name. Don't translate it
     */
    RUN_DISCARD_MESSAGE = 'MICROAPP.RUN_DISCARD_MESSAGE',
    /**
     * @value Micro-app runtime error. Edit actions that contain errors.
     * @description Inform the user that something wrong happened during the run completion
     */
    RUN_FAILED = 'MICROAPP.RUN_FAILED',
    /**
     * @value Enter the mandatory inputs to run the micro-app.
     * @description Inform the user that he need to fill in the interface below to continue run completion
     */
    RUN_FILL_USER_INTERFACE = 'MICROAPP.RUN_FILL_USER_INTERFACE',
    /**
     * @value Run micro-app
     */
    RUN_MICRO_APP = 'MICROAPP.RUN_MICRO_APP',
    /**
     * @value Run micro-app?
     */
    RUN_MICRO_APP_CONFIRMATION = 'MICROAPP.RUN_MICRO_APP_CONFIRMATION',
    /**
     * @value Select connectors to complete run.
     * @description Inform the user that he need to select or create a connector in the list to continue the run
     */
    RUN_SELECT_CONNECTORS = 'MICROAPP.RUN_SELECT_CONNECTORS',
    /**
     * @value Micro-app runtime completed without errors.
     * @description Inform the user that the run is completed with success
     */
    RUN_SUCCEED = 'MICROAPP.RUN_SUCCEED',
    /**
     * @value Select an array
     * @description Placeholder to select an array variable
     */
    SELECT_ARRAY = 'MICROAPP.SELECT_ARRAY',
    /**
     * @value Select connectors to run the micro-app.
     * @description Warning message displayed during run's connector step
     */
    SELECT_CONNECTORS_TO_RUN = 'MICROAPP.SELECT_CONNECTORS_TO_RUN',
    /**
     * @value Select or create a connector
     * @description During run mode inside the builder, let the user know that it has to select or create a connector when facing an error on empty field
     */
    SELECT_CREATE_CONNECTOR = 'MICROAPP.SELECT_CREATE_CONNECTOR',
    /**
     * @value Select LumApps component type
     * @description Title for lumapps component type selection dialog
     */
    SELECT_LUMAPPS_COMPONENT_TYPE = 'MICROAPP.SELECT_LUMAPPS_COMPONENT_TYPE',
    /**
     * @value Select "New provider"
     */
    SELECT_NEW_PROVIDER_TEXT = 'PAGE.MICROAPP_ACTION_DIALOG.SELECT_NEW_PROVIDER_TEXT',
    /**
     * @value Provider of the information where API call will be made.
     * @description Api provider description
     */
    SELECT_PROVIDER_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.SELECT_PROVIDER_DESCRIPTION',
    /**
     * @value Select source language
     * @description custom title for the confirmation dialog during the translation flow inside the micro apps builder
     */
    SELECT_SOURCE_LANGUAGE = 'MICROAPP.SELECT_SOURCE_LANGUAGE',
    /**
     * @value Select a value
     */
    SELECT_VALUE = 'PAGE.MICROAPP.CREATE_FILTER.SELECT_VALUE',
    /**
     * @value Select a variable
     */
    SELECT_VARIABLE = 'PAGE.MICROAPP.CREATE_FILTER.SELECT_VARIABLE',
    /**
     * @value Set as fallback
     */
    SET_AS_FALLBACK = 'PAGE.MICROAPP.LINK.SET_AS_FALLBACK',
    /**
     * @value Set context variables
     */
    SET_CONTEXT_VARIABLES = 'MICROAPP.SET_CONTEXT_VARIABLES',
    /**
     * @value Set variables
     */
    SET_VARIABLES = 'MICROAPP.SET_VARIABLES',
    /**
     * @value Paste
     */
    SHORTCUT_PASTE = 'MICROAPP.SHORTCUT_PASTE',
    /**
     * @value Redo action
     */
    SHORTCUT_REDO = 'MICROAPP.SHORTCUT_REDO',
    /**
     * @value Test selected action
     */
    SHORTCUT_TEST_ACTION = 'MICROAPP.SHORTCUT_TEST_ACTION',
    /**
     * @value Undo action
     */
    SHORTCUT_UNDO = 'MICROAPP.SHORTCUT_UNDO',
    /**
     * @value Select the original language of your content.
     * @description custom source language description for the confirmation dialog during the translation flow inside the micro apps builder
     */
    SOURCE_LANGUAGE_DESCRIPTION = 'MICROAPP.SOURCE_LANGUAGE_DESCRIPTION',
    /**
     * @value Connector
     * @description Label for test connector selector in micro app api call
     */
    TEST_CONNECTOR_DROPDOWN_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.TEST_CONNECTOR_DROPDOWN_LABEL',
    /**
     * @value Select a connector
     * @description Placeholder for test connector selector in micro app api call
     */
    TEST_CONNECTOR_DROPDOWN_PLACEHOLDER = 'PAGE.MICROAPP_ACTION_DIALOG.TEST_CONNECTOR_DROPDOWN_PLACEHOLDER',
    /**
     * @value Test your API call by sending a request using a test connector and values.
     * @description Test section description on micro app api action
     */
    TEST_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.TEST_DESCRIPTION',
    /**
     * @value Execute your function and preview results.
     */
    TEST_FUNCTION_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.TEST_FUNCTION_DESCRIPTION',
    /**
     * @value Test
     * @description Test section label on micro app api action
     */
    TEST_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.TEST_LABEL',
    /**
     * @value Execute your loop and preview results. A maximum of 3 iterations are performed during this test.
     * @description Description for loop test
     */
    TEST_LOOP_DESCRIPTION = 'MICROAPP.TEST_LOOP_DESCRIPTION',
    /**
     * @value Translations
     * @description custom overview helper inside the translation dialog of micro apps
     */
    TRANSLATIONS = 'MICROAPP.TRANSLATIONS',
    /**
     * @value {"one":"%NB% input variable","other":"%NB% input variables"}
     * @description The trigger node description to display the number of input variables
     */
    TRIGGER_ACTION_DESCRIPTION = 'PAGE.MICROAPP_DIALOG.TRIGGER_ACTION_DESCRIPTION',
    /**
     * @value Start
     */
    TRIGGER_ACTION_LABEL = 'PAGE.MICROAPP_DIALOG.TRIGGER_ACTION_LABEL',
    /**
     * @value Upload failed
     * @description error toaster
     */
    UPLOAD_FAILED = 'MICROAPP.UPLOAD_FAILED',
    /**
     * @value Drag and drop the file to upload
     * @description helper located in upload dialog
     */
    UPLOAD_HELPER = 'MICROAPP.UPLOAD_HELPER',
    /**
     * @value Upload JSON file
     * @description upload button label
     */
    UPLOAD_JSON_FILE = 'MICROAPP.UPLOAD_JSON_FILE',
    /**
     * @value If a user’s default language matches your translation, they’ll see the translated content. They can switch back to the original language at any time. <br/>Only completed translations are shown to users.
     * @description custom overview helper inside the translation dialog of micro apps
     */
    USER_CONTENT_ACCESS = 'MICROAPP.USER_CONTENT_ACCESS',
    /**
     * @value Define test values for your data sample.
     */
    VALUES_DESCRIPTION = 'PAGE.MICROAPP_ACTION_DIALOG.VALUES_DESCRIPTION',
    /**
     * @value Values
     */
    VALUES_LABEL = 'PAGE.MICROAPP_ACTION_DIALOG.VALUES_LABEL',
    /**
     * @value Variable
     */
    VARIABLE = 'PAGE.MICROAPP.CREATE_FILTER.VARIABLE',
}
